import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as t } from "./chunks/tslib.es6.js";
import e from "./core/Collection.js";
import { JSONSupport as o } from "./core/JSONSupport.js";
import { clone as s } from "./core/lang.js";
import i from "./core/Logger.js";
import { isPromiseLike as r } from "./core/promiseUtils.js";
import { property as n } from "./core/accessorSupport/decorators/property.js";
import { cast as p } from "./core/accessorSupport/decorators/cast.js";
import { reader as l } from "./core/accessorSupport/decorators/reader.js";
import { subclass as a } from "./core/accessorSupport/decorators/subclass.js";
import { writer as d } from "./core/accessorSupport/decorators/writer.js";
import { ensureOneOfType as f } from "./core/accessorSupport/ensureType.js";
import { collectFields as c, collectArcadeFieldNames as m } from "./layers/support/fieldUtils.js";
import { persistableTypes as u } from "./popup/content.js";
import y from "./popup/ExpressionInfo.js";
import h from "./popup/FieldInfo.js";
import I from "./popup/LayerOptions.js";
import x from "./popup/RelatedRecordsInfo.js";
import { types as F } from "./popup/content/support/mediaInfoTypes.js";
import A from "./support/actions/ActionBase.js";
import _ from "./support/actions/ActionButton.js";
import g from "./support/actions/ActionToggle.js";
import w from "./popup/content/MediaContent.js";
import j from "./popup/content/TextContent.js";
import N from "./popup/content/AttachmentsContent.js";
import C from "./popup/content/FieldsContent.js";
import v from "./popup/content/ExpressionContent.js";
import E from "./popup/content/Content.js";
import O from "./popup/content/CustomContent.js";

var _S;

var T = e.ofType({
  key: "type",
  defaultKeyValue: "button",
  base: A,
  typeMap: {
    button: _,
    toggle: g
  }
}),
    b = {
  base: E,
  key: "type",
  typeMap: {
    media: w,
    custom: O,
    text: j,
    attachments: N,
    fields: C,
    expression: v
  }
},
    R = "esri.PopupTemplate",
    L = i.getLogger(R),
    J = ["attachments", "fields", "media", "text", "expression"];

var M = _S = /*#__PURE__*/function (_o) {
  _inherits(S, _o);

  var _super = _createSuper(S);

  function S() {
    var _this;

    _classCallCheck(this, S);

    _this = _super.apply(this, arguments), _this.actions = null, _this.content = "", _this.expressionInfos = null, _this.fieldInfos = null, _this.layerOptions = null, _this.lastEditInfoEnabled = !0, _this.outFields = null, _this.overwriteActions = !1, _this.returnGeometry = !1, _this.title = "", _this.relatedRecordsInfo = null;
    return _this;
  }

  _createClass(S, [{
    key: "castContent",
    value: function castContent(t) {
      return Array.isArray(t) ? t.map(function (t) {
        return f(b, t);
      }) : "string" == typeof t || "function" == typeof t || t instanceof HTMLElement || r(t) ? t : (L.error("content error", "unsupported content value", {
        value: t
      }), null);
    }
  }, {
    key: "readContent",
    value: function readContent(t, e) {
      var o = e.popupElements;
      return Array.isArray(o) && o.length > 0 ? this._readPopupInfoElements(e) : this._readPopupInfo(e);
    }
  }, {
    key: "writeContent",
    value: function writeContent(t, e, o, s) {
      var _this2 = this;

      "string" != typeof t ? Array.isArray(t) && (e.popupElements = t.filter(function (t) {
        return -1 !== J.indexOf(t.type);
      }).map(function (t) {
        return t && t.toJSON(s);
      }), e.popupElements.forEach(function (t) {
        "attachments" === t.type ? _this2._writeAttachmentContent(e) : "media" === t.type ? _this2._writeMediaContent(t, e) : "text" === t.type && _this2._writeTextContent(t, e);
      })) : e.description = t;
    }
  }, {
    key: "writeFieldInfos",
    value: function writeFieldInfos(t, e, o, s) {
      var i = this.content,
          r = Array.isArray(i) ? i : null;

      if (t) {
        var _o2 = r ? r.filter(function (t) {
          return "fields" === t.type;
        }) : [],
            _i = _o2.length && _o2.every(function (t) {
          var e;
          return null == (e = t.fieldInfos) ? void 0 : e.length;
        });

        e.fieldInfos = t.filter(Boolean).map(function (t) {
          var e = t.toJSON(s);
          return _i && (e.visible = !1), e;
        });
      }

      if (r) {
        var _iterator = _createForOfIteratorHelper(r),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _n = _step.value;
            "fields" === _n.type && this._writeFieldsContent(_n, e);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "writeLayerOptions",
    value: function writeLayerOptions(t, e, o, s) {
      e[o] = !t || null === t.showNoDataRecords && null === t.returnTopmostRaster ? null : t.toJSON(s);
    }
  }, {
    key: "writeTitle",
    value: function writeTitle(t, e) {
      e.title = t || "";
    }
  }, {
    key: "clone",
    value: function clone() {
      var t = this.actions,
          e = t ? s(t.toArray()) : [];
      return new _S({
        actions: e,
        content: Array.isArray(this.content) ? s(this.content) : this.content,
        expressionInfos: Array.isArray(this.expressionInfos) ? s(this.expressionInfos) : null,
        fieldInfos: Array.isArray(this.fieldInfos) ? s(this.fieldInfos) : null,
        layerOptions: this.layerOptions ? s(this.layerOptions) : null,
        lastEditInfoEnabled: this.lastEditInfoEnabled,
        outFields: Array.isArray(this.outFields) ? s(this.outFields) : null,
        overwriteActions: this.overwriteActions,
        returnGeometry: this.returnGeometry,
        title: this.title,
        relatedRecordsInfo: this.relatedRecordsInfo ? s(this.relatedRecordsInfo) : null
      });
    }
  }, {
    key: "collectRequiredFields",
    value: function () {
      var _collectRequiredFields = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t, e) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._collectExpressionInfoFields(t, e, this._getContentExpressionInfos(this.content, this.expressionInfos));

              case 2:
                c(t, e, [].concat(_toConsumableArray(this.outFields || []), _toConsumableArray(this._getActionsFields(this.actions)), _toConsumableArray(this._getTitleFields(this.title)), _toConsumableArray(this._getContentFields(this.content))));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function collectRequiredFields(_x, _x2) {
        return _collectRequiredFields.apply(this, arguments);
      }

      return collectRequiredFields;
    }()
  }, {
    key: "getRequiredFields",
    value: function () {
      var _getRequiredFields = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(t) {
        var e;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                e = new Set();
                _context2.next = 3;
                return this.collectRequiredFields(e, t);

              case 3:
                return _context2.abrupt("return", _toConsumableArray(e).sort());

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getRequiredFields(_x3) {
        return _getRequiredFields.apply(this, arguments);
      }

      return getRequiredFields;
    }()
  }, {
    key: "_writeFieldsContent",
    value: function _writeFieldsContent(t, e) {
      if (!Array.isArray(t.fieldInfos) || !t.fieldInfos.length) return;
      var o = s(t.fieldInfos);
      Array.isArray(e.fieldInfos) ? o.forEach(function (t) {
        var o = e.fieldInfos.find(function (e) {
          return e.fieldName.toLowerCase() === t.fieldName.toLowerCase();
        });
        o ? o.visible = !0 : e.fieldInfos.push(t);
      }) : e.fieldInfos = o;
    }
  }, {
    key: "_writeAttachmentContent",
    value: function _writeAttachmentContent(t) {
      t.showAttachments || (t.showAttachments = !0);
    }
  }, {
    key: "_writeTextContent",
    value: function _writeTextContent(t, e) {
      !e.description && t.text && (e.description = t.text);
    }
  }, {
    key: "_writeMediaContent",
    value: function _writeMediaContent(t, e) {
      if (!Array.isArray(t.mediaInfos) || !t.mediaInfos.length) return;
      var o = s(t.mediaInfos);
      Array.isArray(e.mediaInfos) ? e.mediaInfos = [].concat(_toConsumableArray(e.mediaInfos), _toConsumableArray(o)) : e.mediaInfos = o;
    }
  }, {
    key: "_readPopupInfoElements",
    value: function _readPopupInfoElements(_ref) {
      var t = _ref.description,
          e = _ref.mediaInfos,
          o = _ref.popupElements;
      var s = {
        description: !1,
        mediaInfos: !1
      };
      return o.map(function (o) {
        return "media" === o.type ? (o.mediaInfos || !e || s.mediaInfos || (o.mediaInfos = e, s.mediaInfos = !0), w.fromJSON(o)) : "text" === o.type ? (o.text || !t || s.description || (o.text = t, s.description = !0), j.fromJSON(o)) : "attachments" === o.type ? N.fromJSON(o) : "fields" === o.type ? C.fromJSON(o) : "expression" === o.type ? v.fromJSON(o) : void 0;
      }).filter(Boolean);
    }
  }, {
    key: "_readPopupInfo",
    value: function _readPopupInfo(_ref2) {
      var t = _ref2.description,
          e = _ref2.mediaInfos,
          o = _ref2.showAttachments;
      var s = [];
      return t ? s.push(new j({
        text: t
      })) : s.push(new C()), Array.isArray(e) && e.length && s.push(w.fromJSON({
        mediaInfos: e
      })), o && s.push(N.fromJSON({
        displayType: "auto"
      })), s.length ? s : t;
    }
  }, {
    key: "_getContentElementFields",
    value: function _getContentElementFields(t) {
      var _this3 = this;

      var e = null == t ? void 0 : t.type;
      if ("attachments" === e) return [].concat(_toConsumableArray(this._extractFieldNames(t.title)), _toConsumableArray(this._extractFieldNames(t.description)));
      if ("custom" === e) return t.outFields || [];
      if ("fields" === e) return [].concat(_toConsumableArray(this._extractFieldNames(t.title)), _toConsumableArray(this._extractFieldNames(t.description)), _toConsumableArray(this._getFieldInfoFields(t.fieldInfos || this.fieldInfos)));

      if ("media" === e) {
        var _e = t.mediaInfos || [];

        return [].concat(_toConsumableArray(this._extractFieldNames(t.title)), _toConsumableArray(this._extractFieldNames(t.description)), _toConsumableArray(_e.reduce(function (t, e) {
          return [].concat(_toConsumableArray(t), _toConsumableArray(_this3._getMediaInfoFields(e)));
        }, [])));
      }

      return "text" === e ? this._extractFieldNames(t.text) : [];
    }
  }, {
    key: "_getMediaInfoFields",
    value: function _getMediaInfoFields(t) {
      var e = t.caption,
          o = t.title,
          s = t.value,
          i = s || {},
          _i$fields = i.fields,
          r = _i$fields === void 0 ? [] : _i$fields,
          n = i.normalizeField,
          p = i.tooltipField,
          l = i.sourceURL,
          a = i.linkURL,
          d = [].concat(_toConsumableArray(this._extractFieldNames(o)), _toConsumableArray(this._extractFieldNames(e)), _toConsumableArray(this._extractFieldNames(l)), _toConsumableArray(this._extractFieldNames(a)), _toConsumableArray(r));
      return n && d.push(n), p && d.push(p), d;
    }
  }, {
    key: "_getContentExpressionInfos",
    value: function _getContentExpressionInfos(t, e) {
      return Array.isArray(t) ? t.reduce(function (t, e) {
        return [].concat(_toConsumableArray(t), _toConsumableArray("expression" === e.type && e.expressionInfo ? [e.expressionInfo] : []));
      }, e || []) : [];
    }
  }, {
    key: "_getContentFields",
    value: function _getContentFields(t) {
      var _this4 = this;

      return "string" == typeof t ? this._extractFieldNames(t) : Array.isArray(t) ? t.reduce(function (t, e) {
        return [].concat(_toConsumableArray(t), _toConsumableArray(_this4._getContentElementFields(e)));
      }, []) : [];
    }
  }, {
    key: "_collectExpressionInfoFields",
    value: function () {
      var _collectExpressionInfoFields2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(t, e, o) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = o;

                if (!_context3.t0) {
                  _context3.next = 4;
                  break;
                }

                _context3.next = 4;
                return Promise.all(o.map(function (o) {
                  return m(t, e, o.expression);
                }));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function _collectExpressionInfoFields(_x4, _x5, _x6) {
        return _collectExpressionInfoFields2.apply(this, arguments);
      }

      return _collectExpressionInfoFields;
    }()
  }, {
    key: "_getFieldInfoFields",
    value: function _getFieldInfoFields(t) {
      return t ? t.filter(function (t) {
        return void 0 === t.visible || !!t.visible;
      }).map(function (t) {
        return t.fieldName;
      }).filter(function (t) {
        return -1 === t.indexOf("relationships/") && -1 === t.indexOf("expression/");
      }) : [];
    }
  }, {
    key: "_getActionsFields",
    value: function _getActionsFields(t) {
      var _this5 = this;

      return t ? t.toArray().reduce(function (t, e) {
        return [].concat(_toConsumableArray(t), _toConsumableArray(_this5._getActionFields(e)));
      }, []) : [];
    }
  }, {
    key: "_getActionFields",
    value: function _getActionFields(t) {
      var e = t.className,
          o = t.title,
          s = t.type,
          i = "button" === s || "toggle" === s ? t.image : "";
      return [].concat(_toConsumableArray(this._extractFieldNames(o)), _toConsumableArray(this._extractFieldNames(e)), _toConsumableArray(this._extractFieldNames(i)));
    }
  }, {
    key: "_getTitleFields",
    value: function _getTitleFields(t) {
      return "string" == typeof t ? this._extractFieldNames(t) : [];
    }
  }, {
    key: "_extractFieldNames",
    value: function _extractFieldNames(t) {
      if (!t || "string" != typeof t) return [];
      var e = /{[^}]*}/g,
          o = t.match(e);
      if (!o) return [];
      var s = /\{(\w+):.+\}/,
          i = o.filter(function (t) {
        return !(0 === t.indexOf("{relationships/") || 0 === t.indexOf("{expression/"));
      }).map(function (t) {
        return t.replace(s, "{$1}");
      });
      return i ? i.map(function (t) {
        return t.slice(1, -1);
      }) : [];
    }
  }]);

  return S;
}(o);

t([n({
  type: T
})], M.prototype, "actions", void 0), t([n()], M.prototype, "content", void 0), t([p("content")], M.prototype, "castContent", null), t([l("content", ["description", "fieldInfos", "popupElements", "mediaInfos", "showAttachments"])], M.prototype, "readContent", null), t([d("content", {
  popupElements: {
    type: e.ofType(u)
  },
  showAttachments: {
    type: Boolean
  },
  mediaInfos: {
    type: e.ofType(F)
  },
  description: {
    type: String
  }
})], M.prototype, "writeContent", null), t([n({
  type: [y],
  json: {
    write: !0
  }
})], M.prototype, "expressionInfos", void 0), t([n({
  type: [h]
})], M.prototype, "fieldInfos", void 0), t([d("fieldInfos")], M.prototype, "writeFieldInfos", null), t([n({
  type: I
})], M.prototype, "layerOptions", void 0), t([d("layerOptions")], M.prototype, "writeLayerOptions", null), t([n({
  type: Boolean,
  json: {
    read: {
      source: "showLastEditInfo"
    },
    write: {
      target: "showLastEditInfo"
    },
    default: !0
  }
})], M.prototype, "lastEditInfoEnabled", void 0), t([n()], M.prototype, "outFields", void 0), t([n()], M.prototype, "overwriteActions", void 0), t([n()], M.prototype, "returnGeometry", void 0), t([n({
  json: {
    type: String
  }
})], M.prototype, "title", void 0), t([d("title")], M.prototype, "writeTitle", null), t([n({
  type: x,
  json: {
    write: !0
  }
})], M.prototype, "relatedRecordsInfo", void 0), M = _S = t([a(R)], M);
var B = M;
export { B as default };